import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
  OPPORTUNITY_SETTING: "api/CRM/OpportunitySetting",
  OPPORTUNITY_REASONS: "api/CRM/OpportunityReasons",
  TAGS: "api/CRM/Tags",
  OPPORTUNITY_REASON : "api/CRM/OpportunityReason",
};

const getOpportunitySetting = async (): Promise<ApiResponse<any>> => {
  const res = await privateRequest.get<ApiResponse<any>>(
    ENDPOINTS.OPPORTUNITY_SETTING
  );
  return res.data;
};

const updateOpportunitySetting = async (data: any): Promise<ApiResponse<any>> => {
  const queryParams = new URLSearchParams({
    isReasonRequired: String(data.IsReasonRequired ?? false),
    isProposalAttachmentRequired: String(data.IsProposalAttachmentRequired ?? false),
    isWonAttachmentRequired: String(data.IsWonAttachmentRequired ?? false),
    isOpportunityAttachmentRequired: String(data.IsOpportunityAttachmentRequired ?? false),
  }).toString();

  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.OPPORTUNITY_SETTING}?${queryParams}`,
    data
  );
  return res.data;
};

const getOpportunityReasons = async (): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    ENDPOINTS.OPPORTUNITY_REASONS
  );
  return res.data;
};

const getTags = async (tagTypeId: number = 1): Promise<ApiResponse<any[]>> => {
  const res = await privateRequest.get<ApiResponse<any[]>>(
    `${ENDPOINTS.TAGS}?tagTypeId=${tagTypeId}`
  );
  return res.data;
};

const deleteOpportunityReason = async (id: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.OPPORTUNITY_REASON}/${id}`
  );
  return res.data;
};

const deleteTag = async (id: number, tagTypeId: number): Promise<ApiResponse<any>> => {
  const res = await privateRequest.delete<ApiResponse<any>>(
    `${ENDPOINTS.TAGS}/${id}?tagTypeId=${tagTypeId}`
  );
  return res.data;
};

const addOpportunityReason = async (reason: string): Promise<ApiResponse<any>> => {
  const queryParams = new URLSearchParams({ reason }).toString();
  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.OPPORTUNITY_REASON}?${queryParams}`,
  );
  return res.data;
};

const addTag = async (tagName: string, tagTypeId: number, includeResourceTag?: boolean): Promise<ApiResponse<any>> => {
  const queryParams = new URLSearchParams({ tagName, tagTypeId: String(tagTypeId) });

  if (includeResourceTag !== undefined) {
    queryParams.append("includeResourceTag", String(includeResourceTag));
  }

  const res = await privateRequest.post<ApiResponse<any>>(
    `${ENDPOINTS.TAGS}?${queryParams.toString()}`
  );

  return res.data;
};

const updateTag = async (id: number, payload : object): Promise<ApiResponse<any>> => {
  const res = await privateRequest.put<ApiResponse<any>>(
    `${ENDPOINTS.TAGS}/${id}`,payload
  );
  return res.data;
};

const DealsNPipelineSettingsService = {
  getOpportunitySetting,
  updateOpportunitySetting,
  getOpportunityReasons,
  getTags,
  deleteOpportunityReason,
  deleteTag,
  addOpportunityReason,
  addTag,
  updateTag
};

export default DealsNPipelineSettingsService;
